module.exports = __webpack_public_path__ + "static/img/8.d95ed241.png";